<template>
  <div data-tour-id="samples-register-standard-form">
    <div class="input-full">
      <div>
        <div class="card-content padding">
          <div class="form-container">
            <form>
              <DxForm
                ref="splRegisterForm"
                label-location="top"
                :col-count="10"
                :form-data="formData"
                :element-attr="{ class: 'standard-sample-register-form' }"
              >
                <DxGroupItem :col-count="10" :col-span="10">
                  <DxItem
                    data-field="CodPresupuesto"
                    editor-type="dxSelectBox"
                    css-class="sample-register-first-row-lower"
                    :is-required="true"
                    :col-span="2"
                    :editor-options="{
                      dataSource: store,
                      displayExpr: 'CodOfferTitle',
                      valueExpr: 'CodPresupuesto',
                      searchEnabled: true,
                      dropDownOptions: {
                        width: 620,
                        maxHeight: 320,
                        wrapperAttr: {
                          class:
                            'standard-codPresupuesto-select-dropdown',
                        },
                      },
                    }"
                    :validation-rules="[
                      {
                        type: 'required',
                        message: $t('fillRequiredFields'),
                      },
                    ]"
                  >
                    <DxLabel :text="$t('samplesRegister.budget')" />
                  </DxItem>

                  <DxItem
                    editor-type="dxDateBox"
                    data-field="SamplingDate"
                    :is-required="true"
                    :col-span="2"
                    :editor-options="{
                      type: 'datetime',
                      displayFormat:
                        $helpers.getDateFormat(company) + ' HH:mm',
                      applyValueMode: 'instantly',
                      elementAttr: {
                        class: 'samples-register-datetime-field',
                      },
                      dropDownOptions: {
                        wrapperAttr: {
                          class: 'samples-register-datetime-popup',
                        },
                      },
                    }"
                    :validation-rules="[
                      {
                        type: 'required',
                        message: $t('fillRequiredFields'),
                      },
                    ]"
                  >
                    <DxLabel
                      :text="
                        $t('samplesRegister.samplingDateAndTime')
                      "
                    />
                  </DxItem>
                  <DxItem
                    data-field="FamiliaTM"
                    editor-type="dxSelectBox"
                    css-class="sample-register-first-row-lower"
                    :is-required="true"
                    :col-span="2"
                    :editor-options="{
                      disabled: familiDisabled,
                      dataSource: {
                        store: familiesFiltered,
                        sort: { selector: 'FamiliaTM', desc: false },
                      },
                      displayExpr: 'FamiliaTM',
                      valueExpr: 'idFamiliaTM',
                      searchEnabled: true,
                      dropDownOptions: {
                        width: 620,
                        maxHeight: 320,
                        wrapperAttr: {
                          class: 'standard-familiaTM-select-dropdown',
                        },
                      },
                    }"
                    :validation-rules="[
                      {
                        type: 'required',
                        message: $t('fillRequiredFields'),
                      },
                    ]"
                  >
                    <DxLabel :text="$t('samplesRegister.family')" />
                  </DxItem>

                  <DxItem
                    data-field="Descripcion"
                    editor-type="dxSelectBox"
                    css-class="sample-register-first-row-type"
                    :is-required="true"
                    :col-span="2"
                    :editor-options="{
                      disabled: sampleTypesDisabled,
                      dataSource: {
                        store: sampletypesUi,
                        sort: {
                          selector: 'Descripcion',
                          desc: false,
                        },
                      },
                      displayExpr: 'Descripcion',
                      valueExpr: 'this',
                      searchEnabled: true,
                      dropDownOptions: {
                        width: 620,
                        maxHeight: 320,
                        wrapperAttr: {
                          class:
                            'standard-sampleTypes-select-dropdown',
                        },
                      },
                    }"
                    :validation-rules="[
                      {
                        type: 'required',
                        message: $t('fillRequiredFields'),
                      },
                    ]"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.sampleType')"
                    />
                  </DxItem>

                  <DxItem
                    data-field="SubTipoMuestra"
                    editor-type="dxSelectBox"
                    :col-span="2"
                    :editor-options="{
                      disabled: subSampleTypeVisible,
                      dataSource: {
                        store: subSampleType,
                        sort: {
                          selector: 'Descripcion',
                          desc: false,
                        },
                      },
                      displayExpr: 'Descripcion',
                      valueExpr: 'idSubTipoMuestra',
                      searchEnabled: true,
                      elementAttr: { title: formData.SubTipoMuestra },
                      dropDownOptions: {
                        width: 620,
                        maxHeight: 320,
                        wrapperAttr: {
                          class:
                            'standard-subSampleType-select-dropdown',
                        },
                      },
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.sampleSubtype')"
                    />
                  </DxItem>
                </DxGroupItem>

                <!-- <DxGroupItem :col-count="5" :col-span="10">
                  <DxItem
                    data-field="cloroResidual"
                    editor-type="dxNumberBox"
                    :editor-options="{
                      min: 0,
                      max: 10,
                      step: 0.1,
                      format: '#0.0',
                      showSpinButtons: true,
                      visible: chlorineDisabled,
                    }"
                  >
                    <DxLabel
                      :text="
                        $t('samplesRegister.freeResidualChlorine')
                      "
                      :visible="chlorineDisabled"
                    />
                  </DxItem>
                </DxGroupItem> -->

                <DxGroupItem
                  :col-count="chlorineDisabled ? 24 : 5"
                  :col-span="10"
                >
                  <DxItem
                    data-field="cloroResidual"
                    editor-type="dxNumberBox"
                    :editor-options="{
                      min: 0,
                      max: 10,
                      step: 0.1,
                      format: '#0.0',
                      showSpinButtons: true,
                      visible: chlorineDisabled,
                    }"
                    :visible="chlorineDisabled"
                    :col-span="chlorineDisabled ? 3 : 1"
                  >
                    <DxLabel
                      :text="
                        $t('samplesRegister.freeResidualChlorine')
                      "
                      :visible="chlorineDisabled"
                    />
                  </DxItem>
                  <DxItem
                    editor-type="dxSelectBox"
                    data-field="Articulo"
                    :is-required="true"
                    :editor-options="{
                      disabled: analysisTypeDisabled,
                      dataSource: articlesBySubFamilia,
                      searchEnabled: true,
                      displayExpr: 'AtDescrip',
                      valueExpr: 'CodArticulo',
                      showClearButton: false,
                      dropDownOptions: {
                        width: 620,
                        maxHeight: 320,
                        wrapperAttr: {
                          class:
                            'standard-analysisType-select-dropdown',
                        },
                      },
                    }"
                    :validation-rules="[
                      {
                        type: 'required',
                        message: $t('fillRequiredFields'),
                      },
                    ]"
                    :col-span="chlorineDisabled ? 13 : 3"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.analysisType')"
                    />
                  </DxItem>

                  <DxItem
                    editor-type="dxTextBox"
                    data-field="Sampler"
                    :col-span="chlorineDisabled ? 4 : 1"
                  >
                    <DxLabel :text="$t('samplesRegister.sampler')" />
                  </DxItem>

                  <DxItem
                    data-field="lote"
                    editor-type="dxTextBox"
                    :col-span="chlorineDisabled ? 4 : 1"
                    :editor-options="{
                      maxLength: 50,
                    }"
                  >
                    <DxLabel :text="$t('samplesRegister.lot')" />
                  </DxItem>
                </DxGroupItem>

                <DxGroupItem :col-count="1" :col-span="10">
                  <DxItem
                    data-field="DescripcionMuestra"
                    editor-type="dxTextBox"
                    :is-required="true"
                    :editor-options="{ height: 40, maxLength: 255 }"
                    :validation-rules="[
                      {
                        type: 'required',
                        message: $t('fillRequiredFields'),
                      },
                    ]"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.sampleDescription')"
                    />
                  </DxItem>
                </DxGroupItem>

                <DxGroupItem :col-count="5" :col-span="10">
                  <DxItem
                    editor-type="dxCheckBox"
                    data-field="cma"
                    :editor-options="{
                      disabled: false,
                      visible: checkCma,
                      value: cmaValue,
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.cmaEnabled')"
                      :visible="checkCma"
                      location="left"
                    />
                  </DxItem>

                  <DxItem
                    editor-type="dxSelectBox"
                    data-field="Legislacion"
                    :editor-options="{
                      disabled: false,
                      dataSource: legislations,
                      displayExpr: 'Legislacion',
                      valueExpr: 'idLegislacion',
                      visible: legislationVisible,
                    }"
                    :col-span="4"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.legislation')"
                      :visible="legislationVisible"
                    />
                  </DxItem>
                </DxGroupItem>

                <DxGroupItem
                  :col-count="10"
                  :col-span="10"
                  :visible="hideSamplingPoints"
                >
                  <DxItem
                    editor-type="dxCheckBox"
                    data-field="automaticSamplingPoint"
                    css-class="sample-register-automatic-point"
                    :col-span="3"
                    :editor-options="{
                      disabled: false,
                      visible: true,
                    }"
                    :label="{
                      text: $t(
                        'samplesRegister.automaticSamplingPoint'
                      ),
                      location: 'left',
                      visible: true,
                    }"
                  />

                  <!-- FARM: AUTO -->
                  <DxItem
                    v-if="formData.automaticSamplingPoint"
                    data-field="Parcelas"
                    editor-type="dxSelectBox"
                    :editor-options="{
                      disabled: fincaDisabled,
                      dataSource: farmsWithParcels,
                      displayExpr: 'Finca',
                      valueExpr: 'idFinca',
                      visible: true,
                      searchEnabled: true,
                      dropDownOptions: {
                        width: 620,
                        maxHeight: 320,
                        wrapperAttr: {
                          class: 'standard-finca-select-dropdown',
                        },
                      },
                    }"
                    :col-span="2"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.farm')"
                      :visible="true"
                    />
                  </DxItem>

                  <!-- FARM: MANUAL -->
                  <DxItem
                    v-else
                    data-field="FincaLiteral"
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: false,
                      visible: true,
                    }"
                    :col-span="2"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.farm')"
                      :visible="true"
                    />
                  </DxItem>

                  <!-- PARCEL: AUTO -->
                  <DxItem
                    v-if="formData.automaticSamplingPoint"
                    data-field="Parcela"
                    editor-type="dxSelectBox"
                    :editor-options="{
                      disabled: parcelaDisabled,
                      dataSource: filteredParcels,
                      displayExpr: 'Parcela',
                      valueExpr: 'idParcela',
                      visible: true,
                      searchEnabled: true,
                      dropDownOptions: {
                        width: 620,
                        maxHeight: 320,
                        wrapperAttr: {
                          class: 'standard-parcela-select-dropdown',
                        },
                      },
                    }"
                    :col-span="2"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.plot')"
                      :visible="true"
                    />
                  </DxItem>

                  <!-- PARCEL: MANUAL -->
                  <DxItem
                    v-else
                    data-field="ParcelaLiteral"
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: false,
                      visible: true,
                    }"
                    :col-span="2"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.plot')"
                      :visible="true"
                    />
                  </DxItem>

                  <DxItem
                    v-if="formData.automaticSamplingPoint"
                    data-field="idNivelPunto"
                    editor-type="dxSelectBox"
                    :editor-options="{
                      disabled: !isLevelPointSelectionEnabled,
                      dataSource: filteredLevelPoints,
                      displayExpr: getLevelPointOptionText,
                      valueExpr: 'idNivelPunto',
                      visible: true,
                      searchEnabled: true,
                      placeholder: getLevelPointPlaceholder(),
                      showDropDownButton:
                        isLevelPointSelectionEnabled,
                      onValueChanged: handleLevelPointChange,
                      dropDownOptions: {
                        width: 620,
                        maxHeight: 320,
                        wrapperAttr: {
                          class:
                            'standard-levelPoint-select-dropdown',
                        },
                      },
                    }"
                    :col-span="2"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.pointCoordinate')"
                      :visible="true"
                    />
                  </DxItem>

                  <DxItem
                    v-else-if="false"
                    data-field="NivelPuntoCoordLiteral"
                    editor-type="dxTextBox"
                    :editor-options="{
                      disabled: false,
                      visible: true,
                      onValueChanged: handleLevelPointLiteralChange,
                    }"
                    :col-span="2"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.pointCoordinate')"
                      :visible="true"
                    />
                  </DxItem>
                </DxGroupItem>

                <DxGroupItem :col-count="5" :col-span="10">
                  <DxItem
                    editor-type="dxCheckBox"
                    data-field="lmr"
                    :editor-options="{
                      disabled: false,
                      visible: checkLmr,
                      value: lmrValue,
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.lmrEnabled')"
                      :visible="checkLmr"
                      location="left"
                    />
                  </DxItem>

                  <DxItem
                    data-field="trazaCultivo"
                    editor-type="dxCheckBox"
                    :editor-options="{
                      disabled: false,
                      visible: traceCultiveVisible,
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.trace')"
                      :visible="traceCultiveVisible"
                      location="left"
                    />
                  </DxItem>

                  <DxItem
                    data-field="CultivoOrganico"
                    editor-type="dxCheckBox"
                    :editor-options="{
                      disabled: false,
                      visible: traceCultiveVisible,
                    }"
                  >
                    <DxLabel
                      :text="$t('samplesRegister.organicFarming')"
                      :visible="traceCultiveVisible"
                      location="left"
                    />
                  </DxItem>
                </DxGroupItem>

                <DxItem
                  data-field="Observaciones"
                  editor-type="dxTextArea"
                  :editor-options="{ height: 70, maxLength: 1000 }"
                  :col-span="10"
                >
                  <DxLabel
                    :text="$t('samplesRegister.sampleObservations')"
                  />
                </DxItem>
              </DxForm>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DxForm,
  DxItem,
  DxLabel,
  DxGroupItem,
} from 'devextreme-vue/form';
import { mapActions, mapState } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import EventBus from '@/services/event-bus';

export default {
  components: { DxForm, DxItem, DxLabel, DxGroupItem },
  props: {
    store: { type: [Array, Object, String], default: () => [] },
  },
  data() {
    return {
      formData: {
        CodCliente: null,
        CodPresupuesto: null,
        Sampler: null,
        SamplingDate: null,
        FamiliaTM: null,
        idSubFamiliaTM: null,
        Descripcion: null,
        Articulo: null,
        CodLinea: null,
        cma: null,
        lmr: null,
        Legislacion: null,
        automaticSamplingPoint: false,
        Parcelas: null,
        FincaLiteral: null,
        Parcela: null,
        ParcelaLiteral: null,
        idNivelPunto: null,
        NivelPuntoCoordLiteral: null,
        SubTipoMuestra: null,
        DescripcionMuestra: null,
        Observaciones: null,
        lote: null,
        cloroResidual: null,
        trazaCultivo: false,
        CultivoOrganico: false,
        PrecioAT: null,
        Descuento: null,
      },
      familiDisabled: true,
      sampleTypesDisabled: true,
      subSampleTypeVisible: true,
      analysisTypeDisabled: true,
      traceCultiveVisible: false,
      legislationVisible: false,
      chlorineDisabled: false,
      samplingPointVisible: false,
      analysisType: [],
      familiesFiltered: [],
      offersFamiliesFiltered: [],
      subFamiliesFiltered: [],
      subSampleType: [],
      filteredParcels: [],
      filteredLevelPoints: [],
      fincaDisabled: false,
      parcelaDisabled: false,
      hideSamplingPoints: true,
      checkCma: false,
      cmaValue: false,
      checkLmr: false,
      lmrValue: false,
      idSubFamiliaTiposMuestras: null,
      sampletypesUi: [],
    };
  },
  computed: {
    company() {
      return this.$store?.state?.contact?.company;
    },
    articlesBySubFamilia() {
      const id = this.idSubFamiliaTiposMuestras;
      if (id == null) return [];
      const idNum = Number(id);
      if (Number.isNaN(idNum)) return [];
      return this.analysisType.filter((a) => {
        const sub =
          a.IdSubFamilia != null ? a.IdSubFamilia : a.IdSubFamiliaTM;
        return Number(sub) === idNum;
      });
    },
    isLevelPointSelectionEnabled() {
      return (
        this.formData.automaticSamplingPoint &&
        this.formData.Parcela != null &&
        this.filteredLevelPoints.length > 0
      );
    },
    ...mapState('Offers', [
      'detallesPresupuestos',
      'analisisTipoDescrip',
    ]),
    ...mapState('samplesRegisterModule', [
      'sampletypes',
      'families',
      'offerSelected',
      'legislations',
      'farmsWithParcels',
    ]),
  },
  watch: {
    'formData.CodPresupuesto': async function (nuevoValor) {
      if (nuevoValor) await this.fetchFamilies(nuevoValor);
      else this.resetBudgetDependentFields();
    },

    'formData.FamiliaTM': async function (IdFamilia) {
      this.formData.Descripcion = null;
      this.formData.SubTipoMuestra = null;
      this.subSampleType = [];
      this.subSampleTypeVisible = true;
      this.idSubFamiliaTiposMuestras = null;
      this.analysisTypeDisabled = true;
      this.sampletypesUi = [];

      if (IdFamilia) {
        await this.fetchSubFamiliesFiltered(IdFamilia);
        this.sampletypesUi = Array.isArray(this.sampletypes)
          ? [...this.sampletypes]
          : [];
        if (Number(IdFamilia) === 16) {
          this.sampletypesUi = this.sampletypesUi.filter(
            (item) => Number(item.idTipoMuestra) === 912
          );
          if (this.sampletypesUi.length === 1) {
            this.formData.Descripcion = this.sampletypesUi[0];
          }
        }
      } else {
        this.sampleTypesDisabled = true;
      }

      this.hideSamplingPoints = IdFamilia !== 20;
    },

    'formData.Descripcion': async function (idTipoMuestra) {
      const selectedSampleType =
        idTipoMuestra &&
        typeof idTipoMuestra === 'object' &&
        idTipoMuestra.idTipoMuestra
          ? idTipoMuestra
          : null;

      if (selectedSampleType) {
        this.formData.SubTipoMuestra = null;
        this.analysisTypeDisabled = false;
        this.samplingPointVisible = true;
        this.idSubFamiliaTiposMuestras = Number(
          selectedSampleType.idSubFamiliaTM ??
            selectedSampleType.id_sub_familia
        );
        this.sampletypes.map((item) => {
          if (
            item.idTipoMuestra === selectedSampleType.idTipoMuestra
          ) {
            if (
              item.SubTiposMuestras &&
              item.SubTiposMuestras.length > 0
            ) {
              this.subSampleType = item.SubTiposMuestras;
              this.subSampleTypeVisible = false;
            } else {
              this.subSampleTypeVisible = true;
              this.formData.SubTipoMuestra = null;
            }
          }
          return this.subSampleType;
        });
        await this.analysisTypeFiltered(
          this.formData.FamiliaTM,
          this.idSubFamiliaTiposMuestras
        );
      } else {
        this.formData.SubTipoMuestra = null;
        this.subSampleType = [];
        this.subSampleTypeVisible = true;
        this.analysisTypeDisabled = true;
        this.idSubFamiliaTiposMuestras = null;
        this.analysisType = [];
      }
      this.chlorineDisabled =
        selectedSampleType?.idTipoMuestra === 77;
    },

    'formData.Articulo': async function (CodArticulo) {
      const cma = this.analysisType.find(
        (item) =>
          item.TipoServicioCma !== null &&
          item.CodArticulo === CodArticulo
      );
      const lmr = this.analysisType.find(
        (item) =>
          item.TipoServicioLmr !== null &&
          item.CodArticulo === CodArticulo
      );
      const articulo = this.analysisType.find(
        (item) => item.CodArticulo === CodArticulo
      );

      if (articulo) {
        this.formData.CodLinea = articulo.CodLinea;
        this.formData.idSubFamiliaTM = articulo.IdSubFamilia;
        this.priceDiscount(articulo);
      }

      switch (true) {
        case cma !== undefined:
          this.checkCma = true;
          this.cmaValue = true;
          this.checkLmr = false;
          this.lmrValue = false;
          this.traceCultiveVisible = false;
          this.formData.cma = true;
          this.formData.lmr = false;
          this.formData.trazaCultivo = false;
          this.formData.CultivoOrganico = false;
          break;
        case lmr !== undefined:
          this.checkLmr = true;
          this.lmrValue = true;
          this.checkCma = false;
          this.cmaValue = false;
          this.traceCultiveVisible = true;
          this.formData.cma = false;
          this.formData.lmr = true;
          break;
        default:
          this.checkLmr = false;
          this.checkCma = false;
          this.cmaValue = false;
          this.lmrValue = false;
          this.traceCultiveVisible = false;
          this.formData.cma = false;
          this.formData.lmr = false;
          this.formData.trazaCultivo = false;
          this.formData.CultivoOrganico = false;
      }

      const rawLegislationId = cma?.TipoServicioCma?.IdLegislacion;
      const hasValidLegislationId = Number(rawLegislationId) > 0;

      if (hasValidLegislationId) {
        this.fetchLegislations();
        this.formData.Legislacion = Number(rawLegislationId);
        this.legislationVisible = true;
      } else {
        this.formData.Legislacion = null;
        this.legislationVisible = false;
      }
    },

    idSubFamiliaTiposMuestras() {
      const ok = this.articlesBySubFamilia.some(
        (a) => a.CodArticulo === this.formData.Articulo
      );
      if (!ok) {
        this.formData.Articulo = null;
        this.formData.CodLinea = null;
        this.formData.idSubFamiliaTM = null;
        this.checkCma = false;
        this.cmaValue = false;
        this.checkLmr = false;
        this.lmrValue = false;
        this.traceCultiveVisible = false;
        this.legislationVisible = false;
        this.formData.cma = false;
        this.formData.lmr = false;
        this.formData.trazaCultivo = false;
        this.formData.CultivoOrganico = false;
        this.formData.Legislacion = null;
      }
    },

    'formData.automaticSamplingPoint': function () {
      // Da igual el sentido del cambio: limpiar todo siempre
      this.formData.Parcelas = null;
      this.formData.Parcela = null;
      this.formData.FincaLiteral = null;
      this.formData.ParcelaLiteral = null;
      this.formData.idNivelPunto = null;
      this.formData.NivelPuntoCoordLiteral = null;
      this.filteredParcels = [];
      this.filteredLevelPoints = [];
    },

    // AUTO: al seleccionar finca, filtra parcelas
    'formData.Parcelas': function (idFinca) {
      if (!this.formData.automaticSamplingPoint) return;

      const normalizedIdFinca = this.normalizeSelectionId(idFinca);

      if (normalizedIdFinca !== null) {
        const farm = this.findFarmById(normalizedIdFinca);
        this.filteredParcels = farm ? [...farm.Parcelas] : [];
        this.formData.FincaLiteral = farm ? farm.Finca : null;

        this.formData.Parcela = null;
        this.formData.ParcelaLiteral = null;
        this.formData.idNivelPunto = null;
        this.formData.NivelPuntoCoordLiteral = null;
        this.filteredLevelPoints = [];
      } else {
        this.filteredParcels = [];
        this.formData.FincaLiteral = null;

        this.formData.Parcela = null;
        this.formData.ParcelaLiteral = null;
        this.formData.idNivelPunto = null;
        this.formData.NivelPuntoCoordLiteral = null;
        this.filteredLevelPoints = [];
      }
    },

    // AUTO: al seleccionar parcela, rellena literal
    'formData.Parcela': function (idParcela) {
      if (!this.formData.automaticSamplingPoint) return;

      const normalizedIdParcela =
        this.normalizeSelectionId(idParcela);

      if (normalizedIdParcela != null) {
        const parc = this.findParcelById(normalizedIdParcela);
        this.formData.ParcelaLiteral = parc ? parc.Parcela : null;
        this.filteredLevelPoints = Array.isArray(parc?.nivelPuntos)
          ? [...parc.nivelPuntos]
          : [];
        const currentLevelPointId = this.normalizeSelectionId(
          this.formData.idNivelPunto
        );
        const selectedPoint = this.filteredLevelPoints.find(
          (item) =>
            this.normalizeSelectionId(item?.idNivelPunto) ===
            currentLevelPointId
        );

        if (!selectedPoint) {
          this.formData.idNivelPunto = null;
          this.formData.NivelPuntoCoordLiteral = null;
        } else {
          this.formData.idNivelPunto = currentLevelPointId;
          this.formData.NivelPuntoCoordLiteral =
            this.getLevelPointOptionText(selectedPoint);
        }
      } else {
        this.formData.ParcelaLiteral = null;
        this.filteredLevelPoints = [];
        this.formData.idNivelPunto = null;
        this.formData.NivelPuntoCoordLiteral = null;
      }
    },
    farmsWithParcels: {
      handler() {
        this.syncSamplingPointState();
      },
      deep: true,
    },

    'formData.SamplingDate': async function (date) {
      this.setSamplingDate(date);
    },

    formData: {
      handler(nuevoFormData) {
        const resolvedFormData =
          this.resolveAutomaticSamplingPointSelection(nuevoFormData);
        EventBus.$emit('formData', {
          ...resolvedFormData,
          isExpressMode: false,
        });
      },
      deep: true,
    },
  },

  beforeMount() {
    if (this.offerSelected) {
      try {
        this.$f7.preloader.show();
        this.codOfferPreSelected();
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                JSON.parse(error.message).error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    }

    this.fetchFarmsAndParcels();

    // estado inicial
    this.formData.automaticSamplingPoint = true;
  },

  methods: {
    normalizeSelectionId(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const normalized = Number(value);
      return Number.isNaN(normalized) ? value : normalized;
    },
    findFarmById(idFinca) {
      const normalizedIdFinca = this.normalizeSelectionId(idFinca);
      return (this.farmsWithParcels || []).find(
        (farm) =>
          this.normalizeSelectionId(farm?.idFinca) ===
          normalizedIdFinca
      );
    },
    findParcelById(idParcela) {
      const normalizedIdParcela =
        this.normalizeSelectionId(idParcela);
      return (this.filteredParcels || []).find(
        (parcel) =>
          this.normalizeSelectionId(parcel?.idParcela) ===
          normalizedIdParcela
      );
    },
    getLevelPointsForParcel(idParcela) {
      const parcel = this.findParcelById(idParcela);
      if (Array.isArray(parcel?.nivelPuntos)) {
        return [...parcel.nivelPuntos];
      }
      return [];
    },
    resolveLevelPointFromCurrentSelection(formData = this.formData) {
      if (!formData?.automaticSamplingPoint) {
        return {
          idNivelPunto: null,
          NivelPuntoCoordLiteral: null,
        };
      }

      const levelPoints = this.getLevelPointsForParcel(
        formData.Parcela
      );
      if (!levelPoints.length) {
        return {
          idNivelPunto: null,
          NivelPuntoCoordLiteral: null,
        };
      }

      const normalizedCurrentId = this.normalizeSelectionId(
        formData.idNivelPunto
      );
      const selectedById = levelPoints.find(
        (item) =>
          this.normalizeSelectionId(item?.idNivelPunto) ===
          normalizedCurrentId
      );
      if (selectedById) {
        return {
          idNivelPunto: normalizedCurrentId,
          NivelPuntoCoordLiteral:
            this.getLevelPointOptionText(selectedById),
        };
      }

      const selectedByLiteral = levelPoints.find(
        (item) =>
          this.getLevelPointOptionText(item) ===
          formData.NivelPuntoCoordLiteral
      );
      if (selectedByLiteral) {
        return {
          idNivelPunto: this.normalizeSelectionId(
            selectedByLiteral.idNivelPunto
          ),
          NivelPuntoCoordLiteral:
            this.getLevelPointOptionText(selectedByLiteral),
        };
      }

      return {
        idNivelPunto: null,
        NivelPuntoCoordLiteral:
          formData.NivelPuntoCoordLiteral || null,
      };
    },
    resolveAutomaticSamplingPointSelection(formData = this.formData) {
      if (!formData?.automaticSamplingPoint) {
        return formData;
      }

      const selectedFarm = this.findFarmById(formData.Parcelas);
      const selectedParcel = selectedFarm?.Parcelas?.find(
        (parcel) =>
          this.normalizeSelectionId(parcel?.idParcela) ===
          this.normalizeSelectionId(formData.Parcela)
      );
      const resolvedLevelPoint =
        this.resolveLevelPointFromCurrentSelection(formData);

      return {
        ...formData,
        FincaLiteral:
          selectedFarm?.Finca || formData.FincaLiteral || null,
        ParcelaLiteral:
          selectedParcel?.Parcela || formData.ParcelaLiteral || null,
        idNivelPunto: resolvedLevelPoint.idNivelPunto,
        NivelPuntoCoordLiteral:
          resolvedLevelPoint.NivelPuntoCoordLiteral,
      };
    },
    syncSamplingPointState() {
      if (!this.formData.automaticSamplingPoint) {
        this.filteredParcels = [];
        this.filteredLevelPoints = [];
        return;
      }

      const selectedFarm = this.findFarmById(this.formData.Parcelas);
      this.filteredParcels = Array.isArray(selectedFarm?.Parcelas)
        ? [...selectedFarm.Parcelas]
        : [];
      this.formData.FincaLiteral = selectedFarm?.Finca || null;

      const selectedParcel = this.findParcelById(
        this.formData.Parcela
      );
      this.filteredLevelPoints = Array.isArray(
        selectedParcel?.nivelPuntos
      )
        ? [...selectedParcel.nivelPuntos]
        : [];
      this.formData.ParcelaLiteral = selectedParcel?.Parcela || null;

      const currentLevelPointId = this.normalizeSelectionId(
        this.formData.idNivelPunto
      );
      const selectedPoint = this.filteredLevelPoints.find(
        (item) =>
          this.normalizeSelectionId(item?.idNivelPunto) ===
          currentLevelPointId
      );

      if (selectedPoint) {
        this.formData.idNivelPunto = currentLevelPointId;
        this.formData.NivelPuntoCoordLiteral =
          this.getLevelPointOptionText(selectedPoint);
      } else if (this.filteredLevelPoints.length === 0) {
        this.formData.idNivelPunto = null;
        this.formData.NivelPuntoCoordLiteral = null;
      }
    },
    resetBudgetDependentFields() {
      this.formData.FamiliaTM = null;
      this.formData.idSubFamiliaTM = null;
      this.formData.Descripcion = null;
      this.formData.SubTipoMuestra = null;
      this.formData.Articulo = null;
      this.formData.CodLinea = null;
      this.formData.Legislacion = null;
      this.formData.cma = false;
      this.formData.lmr = false;
      this.formData.trazaCultivo = false;
      this.formData.CultivoOrganico = false;
      this.formData.PrecioAT = null;
      this.formData.Descuento = null;
      this.formData.cloroResidual = null;

      this.familiesFiltered = [];
      this.offersFamiliesFiltered = [];
      this.subFamiliesFiltered = [];
      this.subSampleType = [];
      this.sampletypesUi = [];
      this.analysisType = [];
      this.idSubFamiliaTiposMuestras = null;

      this.familiDisabled = true;
      this.sampleTypesDisabled = true;
      this.subSampleTypeVisible = true;
      this.analysisTypeDisabled = true;
      this.traceCultiveVisible = false;
      this.legislationVisible = false;
      this.chlorineDisabled = false;
      this.checkCma = false;
      this.cmaValue = false;
      this.checkLmr = false;
      this.lmrValue = false;
    },
    resetForModeSwitch() {
      this.formData = {
        CodCliente: null,
        CodPresupuesto: null,
        Sampler: null,
        SamplingDate: null,
        FamiliaTM: null,
        idSubFamiliaTM: null,
        Descripcion: null,
        Articulo: null,
        CodLinea: null,
        cma: null,
        lmr: null,
        Legislacion: null,
        automaticSamplingPoint: true,
        Parcelas: null,
        FincaLiteral: null,
        Parcela: null,
        ParcelaLiteral: null,
        idNivelPunto: null,
        NivelPuntoCoordLiteral: null,
        SubTipoMuestra: null,
        DescripcionMuestra: null,
        Observaciones: null,
        lote: null,
        cloroResidual: null,
        trazaCultivo: false,
        CultivoOrganico: false,
        PrecioAT: null,
        Descuento: null,
      };

      this.filteredParcels = [];
      this.filteredLevelPoints = [];
      this.resetBudgetDependentFields();
    },
    async fetchFamilies(offer) {
      try {
        this.$f7.preloader.show();
        this.resetBudgetDependentFields();
        await this.fetchDetallesPresupuestos(offer);
        await this.fetchFamiliesByHierarchy();

        if (
          this.detallesPresupuestos.length > 0 &&
          this.families.length > 0
        ) {
          this.offersFamiliesFiltered = [
            ...new Set(
              this.detallesPresupuestos.map((item) => item.IdFamilia)
            ),
          ];
          this.familiesFiltered = this.families.filter((item) =>
            this.offersFamiliesFiltered.includes(item.idFamiliaTM)
          );
          this.familiDisabled = false;
        }
      } catch (error) {
        this.resetBudgetDependentFields();
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },

    async fetchSubFamiliesFiltered(IdFamilia) {
      try {
        this.$f7.preloader.show();
        this.subFamiliesFiltered = [
          ...new Set(
            (this.detallesPresupuestos || [])
              .filter(
                (item) =>
                  this.normalizeSelectionId(item?.IdFamilia) ===
                  this.normalizeSelectionId(IdFamilia)
              )
              .map((item) =>
                this.normalizeSelectionId(
                  item?.IdSubFamilia ?? item?.IdSubFamiliaTM
                )
              )
              .filter((value) => value !== null)
          ),
        ];
        await this.fetchSamplesTypes({
          IdFamilia,
          subfamilias: this.subFamiliesFiltered,
        });
        this.sampleTypesDisabled = false;
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },

    async analysisTypeFiltered(idFamilia, idSubFamilia) {
      const normalizedFamilyId = this.normalizeSelectionId(idFamilia);
      const normalizedSubFamilyId =
        this.normalizeSelectionId(idSubFamilia);

      if (
        normalizedFamilyId === null ||
        normalizedSubFamilyId === null
      ) {
        this.analysisType = [];
        return [];
      }

      const matchingLines = (this.detallesPresupuestos || []).filter(
        (item) =>
          this.normalizeSelectionId(item?.IdFamilia) ===
            normalizedFamilyId &&
          this.normalizeSelectionId(
            item?.IdSubFamilia ?? item?.IdSubFamiliaTM
          ) === normalizedSubFamilyId
      );

      if (!matchingLines.length) {
        this.analysisType = [];
        return [];
      }

      this.analysisType = await this.analysisTypeDescrForLine(
        matchingLines
      );
      return this.analysisType;
    },

    getTranslatedSubFamilyLabel(item) {
      const familyId = Number(item?.IdFamilia);
      const subFamilyId = Number(
        item?.IdSubFamilia ?? item?.IdSubFamiliaTM
      );
      const family = (this.families || []).find(
        (entry) => Number(entry?.idFamiliaTM) === familyId
      );
      const subFamily = family?.SubFamiliasTM?.find(
        (entry) => Number(entry?.idSubFamiliaTM) === subFamilyId
      );

      return subFamily?.SubFamiliaTM ?? item?.SubFamiliaTM ?? '';
    },

    async analysisTypeDescrForLine(OffersLines) {
      const codigoClientePresupuesto =
        this.detallesPresupuestos.codCliente;
      const [referenceLine] = OffersLines || [];

      if (!referenceLine) {
        return [];
      }

      let listadoAnalisisTipo = [];

      try {
        this.$f7.preloader.show();
        await this.fetchAnalisisTipo({
          codPlanta:
            referenceLine.CodPlantaCentroProduccionSeleccionada || '',
          idFamiliaTM: referenceLine.IdFamilia,
          idSubFamiliaTM:
            referenceLine.IdSubFamilia ?? referenceLine.IdSubFamiliaTM,
          codCliente: codigoClientePresupuesto,
          codIdioma: null,
        });
        listadoAnalisisTipo = this.analisisTipoDescrip || [];
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
        return [];
      } finally {
        this.$f7.preloader.hide();
      }

      return [...OffersLines].map((item) => {
        let at = null;
        if (
          this.normalizeSelectionId(item?.IdSubFamiliaTM) === 63 ||
          this.normalizeSelectionId(item?.IdSubFamilia) === 63
        ) {
          at = listadoAnalisisTipo.find(
            (analysis) => analysis.AnalisisTipo === item.Articulo
          );
        } else {
          const idAnalisisTipo = String(item.CodArticulo || '').slice(
            1
          );
          at = listadoAnalisisTipo.find(
            (analysis) =>
              analysis.IdAnalisisTipo?.toString() === idAnalisisTipo
          );
        }
        const subFamiliaDescripcion =
          this.getTranslatedSubFamilyLabel(item);

        const analysisDescription =
          at?.DescripcionAT ?? item?.DescripcionAT ?? '';

        return {
          ...item,
          CodAnalisisTipo: at?.CodAnalisisTipo ?? item?.CodAnalisisTipo,
          DescripcionAT:
            at?.IdSubFamiliaTM === 63
              ? at?.CodAnalisisTipo
              : analysisDescription,
          AtDescrip: `${item.Articulo} - ${analysisDescription} - ${subFamiliaDescripcion}`,
        };
      });
    },

    async priceDiscount(articulo) {
      this.formData.PrecioAT =
        articulo.PrecioBruto -
        (articulo.PrecioBruto * articulo.Descuento) / 100;
    },
    getLevelPointOptionText(item) {
      if (!item) return '';
      const label =
        item?.descripcion ||
        item?.Descripcion ||
        item?.nivelPunto ||
        item?.NivelPunto ||
        item?.codigo ||
        item?.Codigo ||
        String(item?.idNivelPunto || '');
      return item?.GPSZ ? `${label} - ${item.GPSZ}` : label;
    },
    getLevelPointPlaceholder() {
      if (!this.formData.automaticSamplingPoint) {
        return this.$t('notApplicable');
      }
      if (this.formData.Parcela == null) {
        return '';
      }
      if (!this.filteredLevelPoints.length) {
        return this.$t('notApplicable');
      }
      return '';
    },
    handleLevelPointChange(e) {
      const selectedPoint = this.filteredLevelPoints.find(
        (item) =>
          this.normalizeSelectionId(item?.idNivelPunto) ===
          this.normalizeSelectionId(e?.value)
      );
      this.formData.idNivelPunto = this.normalizeSelectionId(
        e?.value
      );
      this.formData.NivelPuntoCoordLiteral = selectedPoint
        ? this.getLevelPointOptionText(selectedPoint)
        : null;
    },
    handleLevelPointLiteralChange(e) {
      if (this.formData.automaticSamplingPoint) return;
      this.formData.NivelPuntoCoordLiteral = e?.value ?? null;
    },

    async codOfferPreSelected() {
      this.formData.CodPresupuesto = this.offerSelected;
    },

    ...mapActions('Offers', [
      'fetchDetallesPresupuestos',
      'fetchAnalisisTipo',
    ]),
    ...mapActions('samplesRegisterModule', [
      'fetchSamplesTypes',
      'fetchFamiliesByHierarchy',
      'fetchLegislations',
      'fetchFarmsAndParcels',
      'setSamplingDate',
    ]),
  },
};
</script>

<style>
.standard-sample-register-form .dx-field-item {
  padding-left: 6px !important;
  padding-right: 6px !important;
}

label.dx-field-item-label.dx-field-item-label-location-left {
  margin-right: -12px !important;
}

@media (max-width: 1100px) {
  .standard-sample-register-form .sample-register-first-row-lower .dx-field-item-content {
    position: relative !important;
    top: 20px !important;
  }

  .standard-sample-register-form .sample-register-first-row-type .dx-field-item-content {
    position: relative !important;
    top: 20px !important;
  }

  .standard-sample-register-form [data-field='automaticSamplingPoint'] {
    min-width: 0 !important;
  }

.standard-sample-register-form [data-field='automaticSamplingPoint'] .dx-field-item-label {
    white-space: nowrap !important;
  }
}

@media (max-width: 950px) {
  .standard-sample-register-form .sample-register-first-row-type .dx-field-item-content {
    top: 0 !important;
    transform: none !important;
  }

  .standard-sample-register-form .dx-box-item:has(.sample-register-automatic-point) {
    flex: 4 1 0 !important;
  }
}

.standard-codPresupuesto-select-dropdown {
  z-index: 9999 !important;
}

.standard-codPresupuesto-select-dropdown .dx-overlay-content {
  min-width: 620px !important;
  max-width: 80vw !important;
}

.standard-codPresupuesto-select-dropdown .dx-list-item-content {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 16px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.standard-codPresupuesto-select-dropdown .dx-list-item {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-codPresupuesto-select-dropdown .dx-list-item.dx-state-hover,
.standard-codPresupuesto-select-dropdown
  .dx-list-item.dx-state-focused,
.standard-codPresupuesto-select-dropdown
  .dx-list-item.dx-list-item-selected {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-codPresupuesto-select-dropdown
  .dx-list-item.dx-state-hover
  .dx-list-item-content,
.standard-codPresupuesto-select-dropdown
  .dx-list-item.dx-state-focused
  .dx-list-item-content,
.standard-codPresupuesto-select-dropdown
  .dx-list-item.dx-list-item-selected
  .dx-list-item-content {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-familiaTM-select-dropdown {
  z-index: 9999 !important;
}

.standard-familiaTM-select-dropdown .dx-overlay-content {
  min-width: 620px !important;
  max-width: 80vw !important;
}

.standard-familiaTM-select-dropdown .dx-list-item-content {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 16px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.standard-familiaTM-select-dropdown .dx-list-item {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-familiaTM-select-dropdown .dx-list-item.dx-state-hover,
.standard-familiaTM-select-dropdown .dx-list-item.dx-state-focused,
.standard-familiaTM-select-dropdown
  .dx-list-item.dx-list-item-selected {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-familiaTM-select-dropdown
  .dx-list-item.dx-state-hover
  .dx-list-item-content,
.standard-familiaTM-select-dropdown
  .dx-list-item.dx-state-focused
  .dx-list-item-content,
.standard-familiaTM-select-dropdown
  .dx-list-item.dx-list-item-selected
  .dx-list-item-content {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-sampleTypes-select-dropdown {
  z-index: 9999 !important;
}

.standard-sampleTypes-select-dropdown .dx-overlay-content {
  min-width: 620px !important;
  max-width: 80vw !important;
}

.standard-sampleTypes-select-dropdown .dx-list-item-content {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 16px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.standard-sampleTypes-select-dropdown .dx-list-item {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-sampleTypes-select-dropdown .dx-list-item.dx-state-hover,
.standard-sampleTypes-select-dropdown .dx-list-item.dx-state-focused,
.standard-sampleTypes-select-dropdown
  .dx-list-item.dx-list-item-selected {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-sampleTypes-select-dropdown
  .dx-list-item.dx-state-hover
  .dx-list-item-content,
.standard-sampleTypes-select-dropdown
  .dx-list-item.dx-state-focused
  .dx-list-item-content,
.standard-sampleTypes-select-dropdown
  .dx-list-item.dx-list-item-selected
  .dx-list-item-content {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-subSampleType-select-dropdown {
  z-index: 9999 !important;
}

.standard-subSampleType-select-dropdown .dx-overlay-content {
  min-width: 620px !important;
  max-width: 80vw !important;
}

.standard-subSampleType-select-dropdown .dx-list-item-content {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 16px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.standard-subSampleType-select-dropdown .dx-list-item {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-subSampleType-select-dropdown .dx-list-item.dx-state-hover,
.standard-subSampleType-select-dropdown
  .dx-list-item.dx-state-focused,
.standard-subSampleType-select-dropdown
  .dx-list-item.dx-list-item-selected {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-subSampleType-select-dropdown
  .dx-list-item.dx-state-hover
  .dx-list-item-content,
.standard-subSampleType-select-dropdown
  .dx-list-item.dx-state-focused
  .dx-list-item-content,
.standard-subSampleType-select-dropdown
  .dx-list-item.dx-list-item-selected
  .dx-list-item-content {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-analysisType-select-dropdown {
  z-index: 9999 !important;
}

.standard-analysisType-select-dropdown .dx-overlay-content {
  min-width: 620px !important;
  max-width: 80vw !important;
}

.standard-analysisType-select-dropdown .dx-list-item-content {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 16px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.standard-analysisType-select-dropdown .dx-list-item {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-analysisType-select-dropdown .dx-list-item.dx-state-hover,
.standard-analysisType-select-dropdown .dx-list-item.dx-state-focused,
.standard-analysisType-select-dropdown
  .dx-list-item.dx-list-item-selected {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-analysisType-select-dropdown
  .dx-list-item.dx-state-hover
  .dx-list-item-content,
.standard-analysisType-select-dropdown
  .dx-list-item.dx-state-focused
  .dx-list-item-content,
.standard-analysisType-select-dropdown
  .dx-list-item.dx-list-item-selected
  .dx-list-item-content {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-finca-select-dropdown {
  z-index: 9999 !important;
}

.standard-finca-select-dropdown .dx-overlay-content {
  min-width: 620px !important;
  max-width: 80vw !important;
}

.standard-finca-select-dropdown .dx-list-item-content {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 16px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.standard-finca-select-dropdown .dx-list-item {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-finca-select-dropdown .dx-list-item.dx-state-hover,
.standard-finca-select-dropdown .dx-list-item.dx-state-focused,
.standard-finca-select-dropdown .dx-list-item.dx-list-item-selected {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-finca-select-dropdown
  .dx-list-item.dx-state-hover
  .dx-list-item-content,
.standard-finca-select-dropdown
  .dx-list-item.dx-state-focused
  .dx-list-item-content,
.standard-finca-select-dropdown
  .dx-list-item.dx-list-item-selected
  .dx-list-item-content {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-parcela-select-dropdown {
  z-index: 9999 !important;
}

.standard-parcela-select-dropdown .dx-overlay-content {
  min-width: 620px !important;
  max-width: 80vw !important;
}

.standard-parcela-select-dropdown .dx-list-item-content {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 16px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.standard-parcela-select-dropdown .dx-list-item {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-parcela-select-dropdown .dx-list-item.dx-state-hover,
.standard-parcela-select-dropdown .dx-list-item.dx-state-focused,
.standard-parcela-select-dropdown
  .dx-list-item.dx-list-item-selected {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-parcela-select-dropdown
  .dx-list-item.dx-state-hover
  .dx-list-item-content,
.standard-parcela-select-dropdown
  .dx-list-item.dx-state-focused
  .dx-list-item-content,
.standard-parcela-select-dropdown
  .dx-list-item.dx-list-item-selected
  .dx-list-item-content {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-levelPoint-select-dropdown {
  z-index: 9999 !important;
}

.standard-levelPoint-select-dropdown .dx-overlay-content {
  min-width: 620px !important;
  max-width: 80vw !important;
}

.standard-levelPoint-select-dropdown .dx-list-item-content {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 16px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.standard-levelPoint-select-dropdown .dx-list-item {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-levelPoint-select-dropdown .dx-list-item.dx-state-hover,
.standard-levelPoint-select-dropdown .dx-list-item.dx-state-focused,
.standard-levelPoint-select-dropdown
  .dx-list-item.dx-list-item-selected {
  background-color: #ffffff !important;
  color: #00346a !important;
}

.standard-levelPoint-select-dropdown
  .dx-list-item.dx-state-hover
  .dx-list-item-content,
.standard-levelPoint-select-dropdown
  .dx-list-item.dx-state-focused
  .dx-list-item-content,
.standard-levelPoint-select-dropdown
  .dx-list-item.dx-list-item-selected
  .dx-list-item-content {
  background-color: #ffffff !important;
  color: #00346a !important;
}
</style>
